'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { Menu, X } from 'lucide-react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed w-full top-0 z-50 transition-all duration-300 ${isScrolled
          ? 'bg-white/80 backdrop-blur-md shadow-sm border-b border-gray-200'
          : 'bg-white'
        }`}
    >
      <nav className="mx-auto max-w-7xl px-6 lg:px-8 h-[76px] min-h-[76px]" aria-label="Top">
        <div className="flex items-center justify-between h-full">
          {/* Logo */}
          <div className="flex items-center">
            <Link href="/" className="flex items-center">
              <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-sky-500 to-blue-600">
                Get ATS Ready
              </span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-8">
            <div className="flex space-x-8">
              {['Features', 'How It Works'].map((item) => (
                <a
                  key={item}
                  href={`#${item.toLowerCase().replace(' ', '-')}`}
                  className="text-base font-medium text-gray-700 hover:text-sky-600 transition-colors duration-200"
                >
                  {item}
                </a>
              ))}
            </div>
            <Link
              href="/analyze"
              className="rounded-lg bg-sky-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-sky-700 transition-colors duration-200"
            >
              Analyze Resume
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="flex md:hidden
          ">
            <button
              type="button"
              className="text-gray-700 hover:text-gray-900"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open menu</span>
              <Menu className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile menu */}
      <div
        className={`fixed inset-0 z-50 transform ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'} transition-transform duration-300 ease-in-out md:hidden`}
      >
        <div className="fixed inset-0 bg-black/30" onClick={() => setMobileMenuOpen(false)} />
        <div className="fixed inset-y-0 right-0 flex w-5/6 max-w-sm">
          <div className="relative flex w-full flex-col overflow-y-auto bg-white p-6">
            <div className="flex items-center justify-between mb-8">
              <Link href="/" className="text-2xl font-bold text-sky-600" onClick={() => setMobileMenuOpen(false)}>
                Get ATS Ready
              </Link>
              <button
                type="button"
                className="text-gray-700 hover:text-gray-900"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <X className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="space-y-6">
              {['Features', 'How It Works'].map((item) => (
                <a
                  key={item}
                  href={`#${item.toLowerCase().replace(' ', '-')}`}
                  className="block text-lg font-medium text-gray-900 hover:text-sky-600 transition-colors duration-200"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item}
                </a>
              ))}
              <Link
                href="/analyze"
                className="block w-full rounded-lg bg-sky-600 px-4 py-3 text-center font-medium text-white hover:bg-sky-700 transition-colors duration-200"
                onClick={() => setMobileMenuOpen(false)}
              >
                Analyze Resume
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
